import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CircleTriangleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="circleTriangle" ref={ref} {...props}>
    <path d="M22.58,12.76l-4.27-4.5a8.72,8.72,0,0,0-.92-1l-4.85-5.1a.78.78,0,0,0-1.08,0l-10,10.6a.75.75,0,0,0,.08,1.06A.78.78,0,0,0,2,14H4.09A8,8,0,0,0,20,14h2a.76.76,0,0,0,.69-.45A.78.78,0,0,0,22.58,12.76ZM7,9.1l.53-.56a6.53,6.53,0,0,1,9,0l.53.55a6.55,6.55,0,0,1,1.46,3.44H5.5A6.42,6.42,0,0,1,7,9.1Zm5,10.73A6.56,6.56,0,0,1,5.5,14h13A6.56,6.56,0,0,1,12,19.83Z" />
  </Icon>
)) as IconWithRender;

CircleTriangleIcon.displayName = 'CircleTriangleIcon';
CircleTriangleIcon.renderIcon = (props) => <CircleTriangleIcon {...props} />;
export default CircleTriangleIcon;
